module.exports = __webpack_public_path__ + "static/media/promo-velovod.e74a1f11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-velovod.jpg
// module id = 323
// module chunks = 0